export const config =  {

    '1': {
        '0':{
            '0' : {
                'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Replace sheet metal roofing and install with new fastenings and new flashings.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75 mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs.' +
                    'Additional battens required when existing batten spacings are greater than 900 mm.'
                },
                'ridgeline' : {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of two 90 x 35 mm MGP 12 ridge ties tie at with three 75mm No. 14 Type 17 Screws at each end. One tie on each side of rafters.'
                },
                'wall' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    'Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie-down floor joists to bearers using straps along perimeter of building.',
                    'image' : '09_Wall to Floor.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap under floor joists, connected to wall bottom plates.\n' +
                    ' Two type no.14 type 17 screws required for each end.\n' +
                    ' Screwing through floorboards to reach bottom plates may be required.'
                },
                'pier' : {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie-down floor joists to bearers and connect bearers to piers along the perimeter of the building. ',
                    'image' : '10_Floor to Pier.png',
                    'description' : 'Install two framing anchors per floor joist, connecting to bearers with four 2.8 mm diameter nails per leg. Connection required at every floor joist along perimeter of building.\n' +
                    'Connect bearers to posts with a 50 mm wide, 6 mm thick steel plate fastened with M12 bolts or coach screws.\n' +
                    'Chemical anchors may be used for concrete posts.'
                },

            },
            '1' : {
                'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Replace sheet metal roofing and install with new fastenings and new flashings.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs.'+
                    'Additional battens required when existing batten spacings are greater than 900mm.'
                },
                'ridgeline' : {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end. '
                },
                'wall' :  {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    'Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie-down floor joists to bearers using straps along perimeter of building.',
                    'image' : '09_Wall to Floor.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap under floor joists, connected to wall bottom plates.\n' +
                    ' Two type no.14 type 17 screws required for each end.\n' +
                    ' Screwing through floorboards to reach bottom plates may be required.'
                },
                'pier' : {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie-down floor joists to bearers and connect bearers to piers along the perimeter of the building. ',
                    'image' : '10_Floor to Pier.png',
                    'description' : 'Install two framing anchors per floor joist, connecting to bearers with four 2.8 mm diameter nails per leg. Connection required at every floor joist along perimeter of building.\n' +
                    'Connect bearers to posts with a 50 mm wide, 6 mm thick steel plate fastened with M12 bolts or coach screws.\n' +
                    'Chemical anchors may be used for concrete posts.'
                },
                'internal' : {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : 'Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    'Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    'Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.'
                }

            },
            '2' : {
                'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Install new roofing tiles and battens with sarking.',
                    'image' : '02_Cladding_and_Battens_Tile.png',
                    'description' : 'Remove existing tiles and battens and Install sarking across entire roof. \n' +
                    'Install new tile battens fixed to rafters with one no. 14 type 17 screw.\n' +
                    'Install new tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Install new roofing tiles and battens with sarking.',
                    'image' : '02_Cladding_and_Battens_Tile.png',
                    'description' : 'Remove existing tiles and battens and Install sarking across entire roof. \n' +
                    'Install new tile battens fixed to rafters with one no. 14 type 17 screw.\n' +
                    'Install new tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications.'

                },
                'ridgeline' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Tie rafters together at the ridgeline with two ridge ties for every rafter pair.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of two 90 x 35 mm MGP 12 ridge ties tie at with three 75 mm No. 14 Type 17 Screws at each end. One tie on each side of the rafters.'
                },
                'wall' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : ' Addition of a 30mm wide, 0.8mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    ' Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity.',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '
                },
                'pier' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Cranked bolt.',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '
                },
                'internal' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : 'Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    ' Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    ' Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.  '
                }

            },
            '3' : {
                'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Install new roofing tiles and battens with sarking.',
                    'image' : '02_Cladding_and_Battens_Tile.png',
                    'description' : 'Install sarking across the entire roof. \n' +
                    ' Install new tile battens fixed to rafters with one no. 14 type 17 screw.\n' +
                    ' Refix tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications. '
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Install new roofing tiles and battens with sarking.',
                    'image' : '02_Cladding_and_Battens_Tile.png',
                    'description' : 'Install sarking across the entire roof. \n' +
                    ' Install new tile battens fixed to rafters with one no. 14 type 17 screw.\n' +
                    ' Refix tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications. '

                },
                'ridgeline' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text'  : 'Tie rafters together at the ridgeline with two ridge ties for every rafter pair.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of two 90 x 35 mm MGP 12 ridge ties tie at with three 75 mm No. 14 Type 17 Screws at each end. One tie on each side of the rafters.'
                },
                'wall' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text'  : 'Tie-down rafters to walls using threaded rods into the wall cavity.',
                    'image' : '08_Roof to Wall Rod.png',
                    'description' : 'Addition of tie-down rod (12 mm diameter threaded rod) through rafter and 2 m into brickwork.\n' +
                    'Remove one brick to install 10 mm thick, 150x75mm steel plate across brickwork to secure rod and replace brick.'
                },
                'floor' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity.',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '
                },
                'pier' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text'  : 'Cranked Bolt.',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '
                },
                'internal' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : ' Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    ' Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    ' Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap. '
                }

            },
        },
        '1':{
            '0' : {
                'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Replace sheet metal roofing and install with new fastenings and new flashings.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75 mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs.' +
                    ' Additional battens required when existing batten spacings are greater than 900 mm.'
                },
                'ridgeline' : {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of two 90 x 35 mm MGP 12 ridge ties tie at with three 75mm No. 14 Type 17 Screws at each end. One tie on each side of rafters.'
                },
                'wall' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    'Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie-down floor joists to bearers using straps along perimeter of building.',
                    'image' : '09_Wall to Floor.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap under floor joists, connected to wall bottom plates.\n' +
                    ' Two type no.14 type 17 screws required for each end.\n' +
                    ' Screwing through floorboards to reach bottom plates may be required.'
                },
                'pier' : {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie-down floor joists to bearers and connect bearers to piers along the perimeter of the building. ',
                    'image' : '10_Floor to Pier.png',
                    'description' : 'Install two framing anchors per floor joist, connecting to bearers with four 2.8 mm diameter nails per leg. Connection required at every floor joist along perimeter of building.\n' +
                    'Connect bearers to posts with a 50 mm wide, 6 mm thick steel plate fastened with M12 bolts or coach screws.\n' +
                    'Chemical anchors may be used for concrete posts.'
                },

            },
            '1' : {
                'selection' : 'House: Timber Frame, Medium Roof Pitch, Low-Set, Region: B and C' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Replace sheet metal roofing and install with new fastenings and new flashings.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs.'+
                    'Additional battens required when existing batten spacings are greater than 900mm'
                },
                'ridgeline' : {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end. '
                },
                'wall' :  {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    'Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie-down floor joists to bearers using straps along perimeter of building.',
                    'image' : '09_Wall to Floor.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap under floor joists, connected to wall bottom plates.\n' +
                    ' Two type no.14 type 17 screws required for each end.\n' +
                    ' Screwing through floorboards to reach bottom plates may be required.'
                },
                'pier' : {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Tie-down floor joists to bearers and connect bearers to piers along the perimeter of the building. ',
                    'image' : '10_Floor to Pier.png',
                    'description' : 'Install two framing anchors per floor joist, connecting to bearers with four 2.8 mm diameter nails per leg. Connection required at every floor joist along perimeter of building.\n' +
                    'Connect bearers to posts with a 50 mm wide, 6 mm thick steel plate fastened with M12 bolts or coach screws.\n' +
                    'Chemical anchors may be used for concrete posts.'
                },
                'internal' : {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: B and C' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls',
                    'image' : '06_Underpurlins.png',
                    'description' : 'Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    'Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    'Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.'
                }

            },
            '2' : {
                'selection' : 'House: Low-Set Brick Veneer, Metal Roof, Region: B and C' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Replace sheet metal roofing and install with new fastenings and new flashings.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75 mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs. \n' +
                    ' Additional battens required when existing batten spacings are greater than 900 mm.'

                },
                'ridgeline' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 mm MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end. '
                },
                'wall' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : ' Addition of a 30mm wide, 0.8mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    ' Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity.',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '
                },
                'pier' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Cranked Bolt.',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '
                },
                'internal' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : 'Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    ' Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    ' Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.  '
                }

            },
            '3' : {
                'selection' : 'House: Low-Set Double Brick, Metal Roof, Region: B and C' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: B and C' ,
                    'text'  : 'Replace sheet metal roofing and install with new fastenings and new flashings.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: B and C' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75 mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs. \n' +
                    ' Additional battens required when existing batten spacings are greater than 900 mm.'
                },
                'ridgeline' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 mm MGP 12 ridge tie with three 75 mm No. 14 Type 17 Screws at each end. ' +
                    'Screws at each end. Framing anchors to ridge and hip battens at each rafter. '
                },
                'wall' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text'  : 'Tie-down rafters to walls using threaded rods into the wall cavity.',
                    'image' : '08_Roof to Wall Rod.png',
                    'description' : 'Addition of tie-down rod (12 mm diameter threaded rod) through rafter and 2 m into brickwork.'
                },
                'floor' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity.',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '
                },
                'pier' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text'  : 'Cranked Bolt.',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '
                },
                'internal' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: B and C' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : ' Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    ' Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    ' Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap. '
                }

            },
        }
    },
    '0': {
        '0':{
            '0' : {
                'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Replace sheet metal roofing and install with new fastenings and new flashings.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75 mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs.' +
                    ' Additional battens required when existing batten spacings are greater than 900 mm.'
                },
                'ridgeline' : {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : ' Addition of one 90 x 35 mm MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end.  ' +
                    'Screws at each end. Framing anchors to ridge and hip battens at each rafter. '
                },
                'wall' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    'Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    /*'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '*/
                },
                'pier' : {
                    /*'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Cranked Bolt',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '*/
                },

            },
            '1' : {
                'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs.'+
                    'Additional battens required when existing batten spacings are greater than 900mm'
                },
                'ridgeline' : {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end. '
                },
                'wall' :  {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    'Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    /*'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '*/
                },
                'pier' : {
                    /*'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Cranked Bolt',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '*/
                },
                'internal' : {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : 'Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    'Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    'Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.'
                }

            },
            '2' : {
                'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                'cladding': {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Install new roofing tiles and battens with sarking.',
                    'image' : '02_Cladding_and_Battens_Tile.png',
                    'description' : 'Install sarking across the entire roof.' +
                    ' Install new tile battens fixed to rafters with  one 65 x 3.05 diameter plain shank nail' +
                    ' Refix tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Install new roofing tiles and battens with sarking.',
                    'image' : '02_Cladding_and_Battens_Tile.png',
                    'description' : 'Install sarking across the entire roof.' +
                    ' Install new tile battens fixed to rafters with  one 65 x 3.05 diameter plain shank nail' +
                    ' Refix tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications.'

                },
                'ridgeline' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 mm MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end. '
                },
                'wall' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : ' Addition of a 30mm wide, 0.8mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    ' Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity.',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '
                },
                'pier' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Cranked Bolt.',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '
                },
                'internal' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : 'Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    ' Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    ' Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.  '
                }

            },
            '3' : {
                'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                'cladding': {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Install new roofing tiles and battens with sarking.',
                    'image' : '02_Cladding_and_Battens_Tile.png',
                    'description' : 'Install sarking across the entire roof. \n' +
                    ' Install new tile battens fixed to rafters with  one 65 long  3.05 mm diameter plain shank nail\n' +
                    ' Refix tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications'
                },
                'rafter' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Install new roofing tiles and battens with sarking.',
                    'image' : '02_Cladding_and_Battens_Tile.png',
                    'description' : 'Install sarking across the entire roof. \n' +
                    ' Install new tile battens fixed to rafters with  one 65 long  3.05 mm diameter plain shank nail\n' +
                    ' Refix tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications.'

                },
                'ridgeline' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 mm MGP 12 ridge tie with three 75 mm No. 14 Type 17 Screws at each end. ' +
                    'Screws at each end. Framing anchors to ridge and hip battens at each rafter. '
                },
                'wall' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Tie-down rafters to walls using threaded rods into the wall cavity.',
                    'image' : '08_Roof to Wall Rod.png',
                    'description' : 'Addition of tie-down rod (12 mm diameter threaded rod) through rafter and 2 m into brickwork. ' +
                    'Remove one brick to install 10 mm thick, 150x75mm steel plate across brickwork to secure rod and replace brick.'
                },
                'floor' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity.',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '
                },
                'pier' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Cranked Bolt.',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '
                },
                'internal' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : ' Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    ' Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    ' Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap. '
                }

            },
        },
        '1':{
            '0' : {
                'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Replace sheet metal roofing and install with new fastenings and new flashings.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75 mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs.' +
                    ' Additional battens required when existing batten spacings are greater than 900 mm.'
                },
                'ridgeline' : {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : ' Addition of one 90 x 35 mm MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end.  ' +
                    'Screws at each end. Framing anchors to ridge and hip battens at each rafter. '
                },
                'wall' :  {
                    'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    ' Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    /*'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '*/
                },
                'pier' : {
                    /*'selection' : 'House: Timber Frame, Low Roof Pitch, Region: A' ,
                    'text'  : 'Cranked Bolt',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '*/
                },

            },
            '1' : {
                'selection' : 'House: Timber Frame, Medium Roof Pitch, Low-Set, Region: A' ,
                'cladding': {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs.'+
                    'Additional battens required when existing batten spacings are greater than 900mm.'
                },
                'ridgeline' : {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end. '
                },
                'wall' :  {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : 'Addition of a 30 mm wide, 0.8 mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    'Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    /*'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '*/
                },
                'pier' : {
                    /*'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text'  : 'Cranked Bolt',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '*/
                },
                'internal' : {
                    'selection' : 'House: Timber Frame, Medium Roof Pitch, High-Set, Region: A' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : 'Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    'Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    'Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.'
                }

            },
            '2' : {
                'selection' : 'House: Low-Set Brick Veneer, Metal Roof, Region: A' ,
                'cladding': {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75 mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs. \n' +
                    ' Additional battens required when existing batten spacings are greater than 900 mm.'

                },
                'ridgeline' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 mm MGP 12 ridge tie with three 75mm No. 14 Type 17 Screws at each end. '
                },
                'wall' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Strap every rafter and ceiling joist down to the top of the wall. ',
                    'image' : '07_Roof to Wall Strap.png',
                    'description' : ' Addition of a 30mm wide, 0.8mm thick galvanized metal strap over rafter and ceiling joist.\n' +
                    ' Strap to be screwed to top plate with two No. 14 type 17 screw on each side.'
                },
                'floor' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity.',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '
                },
                'pier' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Cranked Bolt.',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '
                },
                'internal' : {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : 'Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    ' Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    ' Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.  '
                }

            },
            '3' : {
                'selection' : 'House: Low-Set Double Brick, Metal Roof, Region: A' ,
                'cladding': {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '01_Cladding Metal.png',
                    'description' : 'Replace metal roof cladding with a product appropriate for the wind classification of the site and installed according to manufacturer’s specifications.'
                },
                'rafter' :  {
                    'selection' : 'House: Low-Set Brick Veneer, Tile Roof, Region: A' ,
                    'text'  : 'Install an additional screw to every existing nailed batten-to-rafter connection.',
                    'image' : '03_Batten-Rafter Metal.png',
                    'description' : 'Addition of a 75 mm No.14 Type 17 screw through each existing batten into the rafter. Note: Predrilling is essential to ensure no splitting of the existing batten occurs. \n' +
                    ' Additional battens required when existing batten spacings are greater than 900 mm.'

                },
                'ridgeline' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Tie rafters together at the ridgeline with a ridge tie.',
                    'image' : '05_Ridge Ties.png',
                    'description' : 'Addition of one 90 x 35 mm MGP 12 ridge tie with three 75 mm No. 14 Type 17 Screws at each end. ' +
                    'Screws at each end. Framing anchors to ridge and hip battens at each rafter. '
                },
                'wall' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Tie-down rafters to walls using threaded rods into the wall cavity.',
                    'image' : '08_Roof to Wall Rod.png',
                    'description' : 'Addition of tie-down rod (12 mm diameter threaded rod) through rafter and 2 m into brickwork. ' +
                    'Remove one brick to install 10 mm thick, 150x75mm steel plate across brickwork to secure rod and replace brick.'
                },
                'floor' :  {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Install M12 galvanised threaded rods within wall cavity.',
                    'image' : 'retrofit-details-6.png',
                    'description' : 'Addition of tie-down rod (12mm threaded rod) through rafter and unto brickwork. ' +
                    'Remove one brick to install steel plate across brickwork to secure rod and replace. '
                },
                'pier' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text'  : 'Cranked Bolt.',
                    'image' : 'retrofit-details-7.png',
                    'description' : 'Cranked M16 Rod bolted to bearer and pier. '
                },
                'internal' : {
                    'selection' : 'House: Low-Set Double Brick, Tile Roof, Region: A' ,
                    'text' : 'Add framing anchors to tie-down rafters to under purlins and add straps to top and bottom of struts to tie under purlin down to walls.',
                    'image' : '06_Underpurlins.png',
                    'description' : ' Connect each rafter to underpurlin with one framing anchor with four 2.8 mm diameter nails to each leg.\n' +
                    ' Connect top of strut to underpurlin with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap.\n' +
                    ' Connect bottom of strut to wall top plates or strutting beams with two 30 mm wide, 0.8 mm thick galvanized metal straps with two No. 14 type 17 screws at each end of the strap. '
                }

            },
        }
    },

}